import React from "react";
import Instructors from "../components/Profiles/Profile";

function Profiles() {
  return (
    <div>
      <Instructors />
    </div>
  );
}

export default Profiles;
